import Icon from "components/Icon";
import ThreeStateCheckbox from "components/ThreeStateCheckbox";
import React, { useEffect, useRef, useState } from "react";
import "./style-multiselect-two-sides.scss";

interface IMultiselectTwoSides{
  value?:any[];
  options?:{
    label:string;
    value:any;
    [x:string]:any;
  }[];
  onChange?:(values:number[])=>void;
  disabled?:boolean;
  [x:string]:any;
}

export default function MultiselectTwoSides({
  value=[],
  options=[],
  onChange,
  disabled = false
}:IMultiselectTwoSides){

  const [ listSelected, setListSelected ] = useState<any>(value);
  const refArea = useRef(null);
  const [ list, setList ] = useState(options);
  const [ checkedAll, setCheckedAll ] = useState<boolean | undefined>(false);
  
  function renderList(){
    return list.map((item:any,key:number)=>{
      return (
        <div key={key} className="item-for-selection" onClick={disabled?(e)=>{}:(e)=>{
          let current = e.currentTarget;
          let target:any = e.target;
          if(current){
            let input = current.getElementsByTagName("input")[0];
            if(input){
              if(target.tagName === "INPUT"){
                input.checked = target.checked;
              } else {
                input.checked = !input.checked;
              }
              let list_aux:any = [];
              if(input.checked){
                list_aux = [...listSelected];
                list_aux.push(parseInt(input.value));
                setListSelected(list_aux);
                if(onChange)onChange(list_aux)
              } else {
                list_aux = [...listSelected].filter((item:any)=>item !== parseInt(input.value));
                setListSelected(list_aux);
                if(onChange)onChange(list_aux)
              }
            }
          }
        }}>
          <ThreeStateCheckbox disabled={disabled} notClick checked={listSelected.indexOf(item.value) !== -1} value={item.value}/><label>{item.label}</label>
        </div>
      );
    })
  }

  function renderListSelected(){
    return [...list].filter((item:any)=>{
      return listSelected.indexOf(item.value) !== -1
    }).map((item,key)=>{
      return (
        <div key={key} className="item-selected" onClick={disabled?(e)=>{}:()=>{
          let list_aux = [...listSelected].filter((i:any)=>i !== item.value);
          setListSelected(list_aux);
          if(onChange)onChange(list_aux)
          let current:any = refArea.current;
          if(current){
            let elements = current.getElementsByTagName("input");
            for(let i = 0; i < elements.length; i++){
              const element = elements[i];
              if(element.value === item.value.toString()){
                element.checked = false;
              }
            }
          }
        }}>
          <label>{item.label}</label>{disabled?"":<Icon name="faTimes" />}
        </div>
      )
    });
  }

  function updateAllList(event:any){
    let listValues:any = [];
    let current:any = refArea.current;
    if(current){
      let elements = current.getElementsByClassName("item-for-selection");
      for(let i = 0; i < elements.length; i++){
        const element = elements[i];
        let input = element.getElementsByTagName("input")[0];
        if(input && element.style.display !== "none"){
          input.checked = event;
          if(event){
            listValues.push(parseInt(input.value));
          }
        }
      }
    }
    setListSelected(listValues);
    if(onChange)onChange(listValues)
  }

  function getCheckedAll(){
    let aux_true:any = [];
    let aux_false:any = [];
    let current:any = refArea.current;
    if(current){
      let elements = current.getElementsByClassName("item-for-selection");
      for(let i = 0; i < elements.length; i++){
        const element = elements[i];
        let input = element.getElementsByTagName("input")[0];
        if(input && element.style.display !== "none"){
          if(input.checked){
            aux_true.push(parseInt(input.value));
          } else {
            aux_false.push(parseInt(input.value));
          }
        }
      }
    }
    let _r = undefined;
    if(aux_false.length === 0) _r = true;
    if(aux_true.length === 0) _r = false;
    setCheckedAll(_r);
  }

  useEffect(()=>{setList(options)},[options])

  useEffect(()=>{
    getCheckedAll();
  },[listSelected,list]);

  return (
    <div className="multiselect-two-sides">
      <div className="multiselect-two-sides-col">
        <div className="multiselect-two-sides-col-topbar">
          <div className="search">
            <input type="text" onChange={(e)=>{
              let value = e.target.value;
              if(value){
                let current:any = refArea.current;
                if(current){
                  let elements = current.getElementsByClassName("item-for-selection");
                  for(let i = 0; i < elements.length; i++){
                    const element = elements[i];
                    const label = element.getElementsByTagName("label")[0];
                    if(label){
                      if(label.innerText && label.innerText.indexOf(value) === -1){
                        element.style.display = "none";
                      } else {
                        element.style.display = "";
                      }
                    }
                  }
                }
              } else {
                let current:any = refArea.current;
                if(current){
                  let elements = current.getElementsByClassName("item-for-selection");
                  for(let i = 0; i < elements.length; i++){
                    const element = elements[i];
                    element.style.display = "";
                  }
                }
              }
              getCheckedAll();
            }} placeholder="Search..."/>
            <Icon name="search"/>
          </div>
          <div className="controll-all">
            <ThreeStateCheckbox checked={checkedAll} disabled={disabled} onChange={(event)=>{updateAllList(event)}} /><label>Select All</label>
          </div>
        </div>
        <div className="multiselect-two-sides-col-area" ref={refArea}>
          {renderList()}
        </div>
      </div>
      <div className="multiselect-two-sides-col">
        <div className="multiselect-two-sides-col-topbar">
          <div className="controll-quantity">
            <label>{listSelected.length>0?`${listSelected.length} Checked`:"None Selected"}</label>
            {listSelected.length>0&&!disabled?(<label className="clear-all" onClick={()=>{updateAllList(false)}}>Clear All</label>):""}
          </div>
        </div>
        <div className="multiselect-two-sides-col-area">
          {listSelected.length===0?(
            <label className="empty">No Items...</label>
          ):(renderListSelected())}
        </div>
      </div>
    </div>
  );
}